import { render, staticRenderFns } from "./WhistleblowingSystem.vue?vue&type=template&id=1aa7d927&scoped=true&"
import script from "./WhistleblowingSystem.vue?vue&type=script&lang=js&"
export * from "./WhistleblowingSystem.vue?vue&type=script&lang=js&"
import style0 from "./WhistleblowingSystem.vue?vue&type=style&index=0&id=1aa7d927&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7d927",
  null
  
)

export default component.exports